import { ReferenceData } from '../../lib/models/reference-data.model';

export class SelectableOption extends ReferenceData {
  public Selected: boolean;
  public Item: Object;

  constructor(referenceData?: ReferenceData) {
    super(referenceData);
  }

  public setSelectedItem(item: Object): void {
    this.Item = item;
    this.Selected = true;
  }
}
